document.addEventListener('DOMContentLoaded', function () {
  var blogItemSelector = '.article-grid .article-grid--article'
  var loadMoreButton = document.querySelector('[data-article-load-more]')

  function getBlogItemsToShow() {
    var screenWidth = window.innerWidth
    return screenWidth < 768 ? 9 : 12
  }

  function showBlogItems(startIndex, endIndex) {
    var blogItems = document.querySelectorAll(blogItemSelector)
    blogItems.forEach(function (item, index) {
      if (index >= startIndex && index < endIndex) {
        item.classList.add('is-visible')
      } else {
        item.classList.remove('is-visible')
      }
    })
  }

  function checkAndHideLoadMoreButton() {
    var blogItemsContent = document.querySelector('.article-grid')
    if (!blogItemsContent) return

    var remainingHiddenItems = blogItemsContent.querySelectorAll('.article-grid--article:not(.is-visible)')

    if (remainingHiddenItems.length === 0 && loadMoreButton) {
      loadMoreButton.style.display = 'none'
    } else if (loadMoreButton) {
      loadMoreButton.style.display = 'inline-flex'
    }
  }

  function loadMoreArticles() {
    var hiddenBlogItems = document.querySelectorAll(blogItemSelector + ':not(.is-visible)')
    hiddenBlogItems.forEach(function (item, index) {
      if (index < 6) {
        item.classList.add('is-visible')
      }
    })
    checkAndHideLoadMoreButton()
  }

  showBlogItems(0, getBlogItemsToShow())
  checkAndHideLoadMoreButton()

  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', loadMoreArticles)
  }

  // Optional: If you want the layout to respond to screen resizing, uncomment:
  // window.addEventListener('resize', function() {
  //   showBlogItems(0, getBlogItemsToShow())
  //   checkAndHideLoadMoreButton()
  // })
})